import React, { useEffect, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import SaveIcon from '@mui/icons-material/Save';
import { TrackerDataType } from "../../shared/constants/constants";
import { ContentLogKeys, EngagementKeys, IssueKeys, ServiceKeys } from "../../shared/constants/IssueAndServiceKeys";

export default function EditCommsMaterialDialog({ open, onClose, fileData, onSaveItem, onDeleteItem, type }) {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [path, setPath] = useState('');

  useEffect(() => {
    if (fileData) {
      setName(fileData.name || '');
      setDescription(fileData.description || '');
      setPath(fileData.path || '');
    } else {
      setName('');
      setDescription('');
      setPath('');
    }
  }, [fileData]);

  const handleSave = () => {
    if (!name.trim()) {
      alert('File Name is required.');
      return;
    }
    if (!path.trim() && fileData?.type === 'url') {
        alert('Link to File is required for URL types.');
        return;
    }
    if (!path.trim() && fileData?.type !== 'url' && !fileData?._id) {
      alert('File Path is required for new file uploads.');
      return;
    }

    onSaveItem({
      ...fileData,
      name,
      description,
      path,
    });
  };

  const handleDelete = () => {
    if (window.confirm(`Are you sure you want to delete "${fileData?.name}"?`)) {
      onDeleteItem(fileData);
    }
  };

  const isUrlType = fileData?.type === 'url';
  let fileFieldName;
  switch (type) {
    case TrackerDataType.SERVICE:
      fileFieldName = ServiceKeys.file
      break;
    case TrackerDataType.MEDIA_INTERACTION:
      fileFieldName = IssueKeys.file
      break;
    case TrackerDataType.ENGAGEMENT:
      fileFieldName = EngagementKeys.file
      break;
    case TrackerDataType.CONTENT_LOG:
      fileFieldName = ContentLogKeys.file;
      break;
    default:
      fileFieldName = ServiceKeys.file;
      break;
  }

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>
        Edit {fileFieldName}
        {fileData?.name && <Typography variant="caption" display="block">Editing: {fileData.name}</Typography>}
      </DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          id="name"
          label={
            type === TrackerDataType.SERVICE ||
            type === TrackerDataType.ENGAGEMENT ||
            type === TrackerDataType.CONTENT_LOG
              ? 'File Name'
              : 'Story name'
          }
          type="text"
          fullWidth
          variant="standard"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
        />
        <TextField
          margin="dense"
          id="description"
          label="Description"
          type="text"
          fullWidth
          variant="standard"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
        />
        <TextField
          margin="dense"
          id="path"
          label={
            type === TrackerDataType.SERVICE ||
            type === TrackerDataType.ENGAGEMENT ||
            type === TrackerDataType.CONTENT_LOG
              ? 'Link to File'
              : 'URL to Story'
          }
          type="text"
          fullWidth
          variant="standard"
          value={isUrlType ? path : ''}
          onChange={(e) => setPath(e.target.value)}
          required={isUrlType}
          disabled={!isUrlType && fileData?._id}
        />
         {(!isUrlType && fileData?._id) && (
          <Typography variant="caption" display="block" sx={{ mt: 0.5 }}>
            File path for uploaded files cannot be changed here. To change the file itself, please delete and re-upload.
          </Typography>
        )}
      </DialogContent>
      <DialogActions sx={{ padding: '16px 24px' }}>
        <Button
          onClick={onClose}
          color="inherit"
          variant="outlined"
        >
          Cancel
        </Button>
        <Button
          onClick={handleDelete}
          color="error"
          variant="outlined"
          startIcon={<DeleteIcon />}
          disabled={!fileData?._id}
        >
          Delete
        </Button>
        <Button
          onClick={handleSave}
          color="primary"
          variant="contained"
          startIcon={<SaveIcon />}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
